module.exports = __webpack_public_path__ + "img/login4.0a2bca3d.jpg";